import * as React from 'react';
import { navigate } from 'router';

import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import UserCreatePopup from '~/apps/pos/admin/containers/users/UserCreatePopup';


export default function() {
  return (
    <CurrentOrgInjector
      component={UserCreatePopup}
      onReturn={() => navigate('pos.admin.settings.team')}
    />
  );
};
